import * as React from "react";
import { Maximize, Eye, Users, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const rooms = [{
  id: "mowing",
  title: "MOWING",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/precision_mowing_service.png",
  sqm: "Weekly Care",
  view: "Striping",
  occupancy: "Elite Finish",
  link: "#start-your-transformation"
}, {
  id: "landscaping",
  title: "LANDSCAPING",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/architectural_landscaping_design.png",
  sqm: "Custom Design",
  view: "Hardscape",
  occupancy: "Full Install",
  link: "#start-your-transformation"
}, {
  id: "mulching",
  title: "MULCHING",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/premium_mulch_installation.png",
  sqm: "Soil Health",
  view: "Clean Edges",
  occupancy: "Seasonal",
  link: "#start-your-transformation"
}, {
  id: "patios",
  title: "PATIOS",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/luxury_stone_patios.png",
  sqm: "Stone Work",
  view: "Outdoor Living",
  occupancy: "Lifetime",
  link: "#start-your-transformation"
}, {
  id: "seasonal",
  title: "SEASONAL SERVICES",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673628/img/seasonal_cleanup_maintenance.png",
  sqm: "Year-Round",
  view: "Cleanup",
  occupancy: "All Seasons",
  link: "#start-your-transformation",
  description: "Comprehensive fall cleanup, spring preparation, and professional winter snow management.",
  buttonLabel: "View Seasonal Plans"
}];
export default function ArtisanSanctuaries() {
  return <section data-section-id="222071" id="our-core-expertise" className="dark bg-background py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" style={{
    backgroundImage: `radial-gradient(circle at 2px 2px, rgba(141, 198, 63, 0.05) 1px, transparent 0)`,
    backgroundSize: '40px 40px'
  }}>
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #8DC63F 0, #8DC63F 1px, transparent 0, transparent 50%)',
      backgroundSize: '10px 10px'
    }}>
      </div>

      <div className="relative mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-default text-4xl font-bold tracking-widest text-foreground uppercase sm:text-5xl">
            Our Core Expertise
          </h2>
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            Elite landscaping solutions for those who demand precision. We work hard so you can enjoy more.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {rooms.map((room, i) => <div key={room.id} data-index={i} className="group flex flex-col overflow-hidden rounded-lg bg-card border border-border/30 shadow-md transition-all duration-500 hover:bg-accent/10 hover:shadow-2xl hover:-translate-y-1">
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img src={room.image} data-wvc-srcset={`${room.image}-wvc-srcset`} data-wvc-sizes={`${room.image}-wvc-sizes`} alt={room.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent opacity-60" />
              </div>
              
              <div className="flex flex-1 flex-col justify-between p-6">
                <div>
                  <h3 className="font-default text-2xl font-bold text-foreground mb-4 tracking-wider uppercase">
                    {room.title}
                  </h3>

                  {room.description && <p className="mb-4 text-sm text-muted-foreground font-default leading-relaxed">
                      {room.description}
                    </p>}
                  
                  <ul className="mb-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground font-default">
                    <li className="flex items-center gap-2">
                      <Maximize className="h-4 w-4 text-chart-3 transition-transform duration-300 group-hover:scale-110 group-hover:animate-pulse" />
                      <span>{room.sqm}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <Eye className="h-4 w-4 text-chart-3 transition-transform duration-300 group-hover:scale-110 group-hover:animate-pulse" />
                      <span>{room.view}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <Users className="h-4 w-4 text-chart-3 transition-transform duration-300 group-hover:scale-110 group-hover:animate-pulse" />
                      <span>{room.occupancy}</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-auto pt-4 border-t border-border/20">
                  <Link to={room.link} className="group/link relative inline-flex w-fit items-center gap-2 pb-1 text-sm font-bold tracking-widest text-primary transition-colors hover:text-primary/80 uppercase">
                    {room.buttonLabel || "View Service"}
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    <span className="absolute bottom-0 left-0 h-[2px] w-full origin-bottom-right scale-x-0 bg-primary transition-transform duration-300 ease-out group-hover/link:origin-bottom-left group-hover/link:scale-x-100" />
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}